import { useNewStrategyWizardStore } from '../strategyWizardStore';
import type { StateCreator } from 'zustand';
import type {
  DefinitionFormStoreState,
  RebalanceSchedulerSlice,
} from '../types/definitionFormStoreTypes';
import type { RebalanceScheduler } from '@/features/Strategies/features/SmartStrategyDefinitonForm/types';

const getInitialData = (): RebalanceScheduler => {
  const { metadata } = useNewStrategyWizardStore.getState();
  return {
    start_date: metadata.startDate ?? '',
    end_date: metadata.endDate ?? '',

    recon_scheduler: {
      frequency: 'M',
      timing: 'CUSTOM_INTRA_MONTH',
      first_month: null,
      week_of_month: 3,
      weekday: 'FRI',
      ref_date: 'PREV_MONTH_END',
      custom_lag_days: null,
    },

    is_rebal_activated: false,

    // Kept fully populated even while deactivated so toggling doesn't lose
    // the user's settings; the backend nullifies it when is_rebal_activated
    // is false (RebalanceSchedulerConfig._normalize_disabled_rebal_scheduler).
    rebal_scheduler: {
      rebal_methodology: 'calendar_based',
      frequency: 'M',
      timing: 'CUSTOM_INTRA_MONTH',
      first_month: null,
      week_of_month: 3,
      weekday: 'FRI',
      ref_date: 'TWO_MONTHS_PRIOR',
      custom_lag_days: null,
      rebal_target: 'use_existing',
    },
  };
};

export const createRebalanceSchedulerSlice: StateCreator<
  DefinitionFormStoreState,
  [['zustand/immer', never]],
  [],
  RebalanceSchedulerSlice
> = (set) => ({
  rebalance_scheduler: getInitialData(),
  schedulerSeededUniverse: null,

  setSchedulerSeededUniverse: (universe) =>
    set((state) => {
      state.schedulerSeededUniverse = universe;
    }),

  setRebalanceScheduler: (scheduler) =>
    set((state) => {
      Object.assign(state.rebalance_scheduler, scheduler);
    }),

  setReconScheduler: (config) =>
    set((state) => {
      Object.assign(state.rebalance_scheduler.recon_scheduler, config);
    }),

  setRebalScheduler: (config) =>
    set((state) => {
      Object.assign(state.rebalance_scheduler.rebal_scheduler, config);
    }),

  setIsRebalActivated: (activated) =>
    set((state) => {
      state.rebalance_scheduler.is_rebal_activated = activated;
    }),
});
